import React, { useEffect, useState, Suspense } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Table, Avatar, Row } from 'antd'
import '../../css/customer.scss'
import { fetchCompanies } from '../../store/action/company.action'
import {
  loginAsCustomer,
  loginAsCompany,
} from '../../store/action/profile.action'
import { formatPhoneNumberIntl } from 'react-phone-number-input'

const CompanyTable = (props) => {
  var history = useHistory()

  useEffect(() => {
    fetchCompanyList(
      { current: 1, pageSize: 20 },
      { order: 'ascend', field: 'name' }
    )
  }, [])

  var fetchCompanyList = (pagination, sorter) => {
    props.fetchCompanies({
      pagination,
      searchText: props.searchText,
    })
  }

  var formatdata = (data) => {
    data && data.forEach((e, i) => (e.key = e._id))
    return data
  }

  var dataSource = formatdata(props.companies)
  var pagination = {
    ...props.pagination,
    showSizeChanger: true,
  }

  var renderName = (name, obj) => {
    return (
      <Row className={'nameRow'}>
        <Avatar src={obj?.logo}>{name ? name[0]?.toUpperCase() : ''}</Avatar>
        <span>{_.upperFirst(name)}</span>
      </Row>
    )
  }

  var handleRowClick = (record) => {
    // Scope the session to this company so the detail page's user
    // add/edit/delete flows resolve state.profile.company, then open detail.
    props.loginAsCompany(record)
    history.push('/companies/' + record?._id)
  }

  var handleRow = (record, rowIndex) => {
    return {
      onClick: () => handleRowClick(record),
    }
  }

  var handleLoginAs = (e, row) => {
    e.stopPropagation()
    history.push('/companies/edit/' + row._id)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (name, obj) => renderName(name, obj),
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      render: (phone, obj) => formatPhoneNumberIntl(obj.phone ? obj.phone : ''),
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Contact - Name',
      dataIndex: 'contact',
      render: (contact, obj) => contact?.name,
    },
    {
      title: 'Contact - Email',
      dataIndex: 'contact',
      render: (contact, obj) => contact?.email,
    },
    {
      title: 'Contact - Phone',
      dataIndex: 'contact',
      render: (contact, obj) =>
        formatPhoneNumberIntl(contact?.phone ? contact?.phone : ''),
    },
    {
      title: 'City',
      dataIndex: 'address',
      render: (address, obj) => address?.city,
    },
    {
      title: 'State',
      dataIndex: 'address',
      render: (address, obj) => address?.state,
    },
    {
      title: 'ZIp',
      dataIndex: 'address',
      render: (address, obj) => address?.zip,
    },
    {
      title: 'ACTION',
      align: 'center',
      width: '200px',
      render: (row, obj) => (
        <Link onClick={(e) => handleLoginAs(e, row)}>Edit</Link>
      ),
    },
  ]

  return (
    <>
      <Table
        size={'large'}
        className={'custom-table'}
        columns={columns}
        dataSource={dataSource}
        loading={props.isLoading}
        pagination={pagination}
        onChange={fetchCompanyList}
        bordered={false}
        onRow={handleRow}
      />
    </>
  )
}

CompanyTable.propTypes = {
  fetchSurgeon: PropTypes.func.isRequired,
  surgeons: PropTypes.array,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  pagination: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSurgeons: PropTypes.array,
  active: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    companies: state.company.companies,
    searchText: state.company.searchText,
    pagination: state.company.pagination,
    isLoading: state.company.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCompanies: (params) => dispatch(fetchCompanies(params)),
    loginAsCustomer: (customer) => dispatch(loginAsCustomer(customer)),
    loginAsCompany: (company) => dispatch(loginAsCompany(company)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTable)
